"use client";
import s from "./ArticleLikeDislike.module.scss";
import cs from "@/styles/modules/card.module.scss";
import cn from "classnames";
import { Button } from "@/components/UI/Buttons/Button";
import { useEffect, useState } from "react";
import { IconImage } from "@/components/UI/IconImage";

type ArticleLikeDislikeProps = {
  slug: string;
};

const LS_KEY = "blog_article_feedbacks";

enum DisplayStatuses {
  Unitialized = 1,
  VoteRequired,
  JustVoted,
  Done,
}

export const ArticleLikeDislike = ({ slug }: ArticleLikeDislikeProps) => {
  const [status, setStatus] = useState<DisplayStatuses>(DisplayStatuses.Unitialized);
  const [feedbacksArr, setFeedbacksArr] = useState<string[]>([]);

  useEffect(() => {
    const storageData = localStorage.getItem(LS_KEY);

    if (!storageData) {
      setStatus(DisplayStatuses.VoteRequired);
      return;
    }

    try {
      const data = JSON.parse(String(storageData));

      if (!Array.isArray(data)) {
        setStatus(DisplayStatuses.VoteRequired);
        return;
      }

      setFeedbacksArr(data);
      setStatus(data.includes(slug) ? DisplayStatuses.Done : DisplayStatuses.VoteRequired);
    } catch (err) {
      setStatus(DisplayStatuses.VoteRequired);
    }
  }, [slug]);

  const handleVote = async (like: boolean) => {
    try {
      await fetch(`/api/rate-article?slug=${slug}&rate=${like}`);
    } catch (err) {}

    localStorage.setItem(LS_KEY, JSON.stringify([...feedbacksArr, slug]));
    setStatus(DisplayStatuses.JustVoted);
  };

  switch (status) {
    case DisplayStatuses.VoteRequired:
      return (
        <div className={s.wrapper}>
          <h3 className={cn(cs.h3, s.title)}>Was this helpful?</h3>
          <div className={s.buttons}>
            <Button
              type="white"
              outline
              icon="thumbs-up"
              iconPosition="suffix"
              onClick={() => handleVote(true)}
            >
              Yes
            </Button>
            <Button
              type="white"
              outline
              icon="thumbs-down"
              iconPosition="suffix"
              onClick={() => handleVote(false)}
            >
              No
            </Button>
          </div>
        </div>
      );
    case DisplayStatuses.JustVoted:
      return (
        <div className={s.wrapper}>
          <IconImage size={48} icon="winking-face" className={s.successIcon} />
          <h3 className={cn(cs.h3)}>Thank you for your feedback!</h3>
        </div>
      );
    default:
      return null;
  }
};
